import React from "react";
import { Dayjs } from "dayjs";
import { DateLabelButton, DateLabelButtonWrapper } from "@components/inputs/date/popup/Calendar.styles";
import { capitalize } from "@utils/string";
import DateType, { DateFormat } from "../../../../types/Date";
import { IFocusableItemProps } from "@components/focusManager";
import { KeyName } from "../../../../keyName";

interface IMonthProps {
    date: Dayjs;
    onMouseEnter: (month: Dayjs) => void;
    onMouseLeave: (month: Dayjs) => void;
    onClick: (month: Dayjs) => void;
    isFirst?: boolean;
    isLast?: boolean;
    itemProps?: IFocusableItemProps;
    isSelected?: boolean;
    isDisabled?: boolean;
    isInActiveRange?: boolean;
    isInSelectedRange?: boolean;
}

export class Month extends React.PureComponent<IMonthProps> {
    getMonthLabel = (date: Dayjs): string => {
        return capitalize(DateType.format(date, DateFormat.month));
    };

    handleMouseEnter = () => {
        this.props.onMouseEnter(this.props.date);
    };

    handleMouseLeave = () => {
        this.props.onMouseLeave(this.props.date);
    };

    handleMonthClick = () => {
        if (!this.props.isDisabled) {
            this.props.onClick(this.props.date);
        }
    };

    handleKeyDown = (event: React.KeyboardEvent) => {
        if (this.props.onClick && [KeyName.Enter, KeyName.Space].includes(event.key as KeyName)) {
            this.props.onClick(this.props.date);
            event.stopPropagation();
            event.preventDefault();
        }
    };

    render() {
        const {
            date,
            itemProps,
            isSelected,
            isDisabled,
            isInSelectedRange,
            isInActiveRange,
            isFirst,
            isLast
        } = this.props as IMonthProps;
        const month = this.getMonthLabel(date);

        return <DateLabelButtonWrapper
                $isSelected={isSelected}
                $isDisabled={isDisabled}
                $isInActiveRange={isInActiveRange}
                $isInSelectedRange={isInSelectedRange}
                $isFirst={isFirst}
                $isLast={isLast}>
            <DateLabelButton key={date.toString()}
                             $isSelected={isSelected}
                             $isDisabled={isDisabled}
                             onClick={this.handleMonthClick}
                             onMouseEnter={this.handleMouseEnter}
                             onMouseLeave={this.handleMouseLeave}
                             onKeyDown={this.handleKeyDown}
                             onFocus={this.handleMouseEnter}
                             onBlur={this.handleMouseLeave}
                             {...itemProps}>
                {month}
            </DateLabelButton>
        </DateLabelButtonWrapper>
    }
}
